import Model from "./Model";

export default class extends Model {
    async loadTable(page, limit, search = '') {
        let response = await super.list(page, limit, search).then(result => {return result});
        let result = {
            tbody: [],
            pages: response.pages,
        };
        if(response.items !== undefined && response.items.length > 0)
        {
            response.items.forEach(deviceType => {
                let telem = {
                    tbody: {}
                };
                telem.id = deviceType.id;
                telem.tbody.name = deviceType.name;
                telem.tbody.pay_per_month = deviceType.pay;
                result.tbody.push(telem);
            });
        }
        return result;
    }
}
